import * as sign from './sign';

async function changeStates( store, states ) {

  store.setState( states );

}

export {

  changeStates,
  sign
  
}